import { render, staticRenderFns } from "./boxplot.vue?vue&type=template&id=367ec23e&scoped=true"
import script from "./boxplot.vue?vue&type=script&lang=js"
export * from "./boxplot.vue?vue&type=script&lang=js"
import style0 from "./boxplot.vue?vue&type=style&index=0&id=367ec23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ec23e",
  null
  
)

export default component.exports